/* LiberLive Store Trial — single-store mini map (Leaflet + OSM, no API key).
   Lazy-loads Leaflet only when a map container scrolls into view. Per-instance,
   cleans up on shopify:section:unload. */
(function () {
  var LEAFLET_CSS = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
  var LEAFLET_JS = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
  var loadingPromise = null;

  function loadLeaflet() {
    if (window.L) return Promise.resolve(window.L);
    if (loadingPromise) return loadingPromise;
    loadingPromise = new Promise(function (resolve, reject) {
      if (!document.getElementById('llst-leaflet-css')) {
        var link = document.createElement('link');
        link.id = 'llst-leaflet-css'; link.rel = 'stylesheet'; link.href = LEAFLET_CSS;
        document.head.appendChild(link);
      }
      var s = document.createElement('script');
      s.src = LEAFLET_JS; s.async = true;
      s.onload = function () { resolve(window.L); };
      s.onerror = function () { reject(new Error('leaflet failed')); };
      document.head.appendChild(s);
    });
    return loadingPromise;
  }

  function pinIcon(L, color) {
    return L.divIcon({
      className: 'llst-pin',
      html: '<svg width="30" height="38" viewBox="0 0 30 38" xmlns="http://www.w3.org/2000/svg">' +
            '<path d="M15 0C6.7 0 0 6.7 0 15c0 10.5 15 23 15 23s15-12.5 15-23C30 6.7 23.3 0 15 0z" fill="' + color + '"/>' +
            '<circle cx="15" cy="15" r="6" fill="#fff"/></svg>',
      iconSize: [30, 38], iconAnchor: [15, 38], popupAnchor: [0, -34]
    });
  }

  function initMap(el) {
    if (el.__llstMapInit) return;
    el.__llstMapInit = true;
    var lat = parseFloat(el.getAttribute('data-lat'));
    var lng = parseFloat(el.getAttribute('data-lng'));
    var zoom = parseInt(el.getAttribute('data-zoom'), 10) || 15;
    var label = el.getAttribute('data-label') || '';
    var accent = el.getAttribute('data-accent') || '#174BFF';
    if (isNaN(lat) || isNaN(lng)) return;
    loadLeaflet().then(function (L) {
      var map = L.map(el, {
        scrollWheelZoom: false, zoomControl: true, attributionControl: true, dragging: true
      }).setView([lat, lng], zoom);
      el.__llstMap = map;
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19, attribution: '&copy; OpenStreetMap'
      }).addTo(map);
      var m = L.marker([lat, lng], { icon: pinIcon(L, accent), title: label }).addTo(map);
      if (label) m.bindPopup(label);
      el.__llstMarker = m;
      // Let the section re-point this map to another branch (switcher/shuffle) without re-init
      el.__llstUpdate = function (newLat, newLng, newLabel) {
        if (isNaN(newLat) || isNaN(newLng)) return;
        map.setView([newLat, newLng], zoom);
        m.setLatLng([newLat, newLng]);
        if (newLabel) { m.bindPopup(newLabel); if (m.options) { m.options.title = newLabel; } }
        setTimeout(function () { map.invalidateSize(); }, 60);
      };
      // fix tiles when container was hidden/resized
      setTimeout(function () { map.invalidateSize(); }, 200);
    }).catch(function () {
      el.classList.add('is-mapfail');
    });
  }

  function boot(root) {
    var el = (root || document).querySelector('[data-llst-map]');
    if (!el || el.__llstObserved) return;
    el.__llstObserved = true;
    // Prefer lazy init when the map scrolls near view; guarantee init with an
    // idle/timeout fallback so it never depends solely on the observer firing.
    var started = false;
    var go = function () { if (started) return; started = true; if (el.__llstIO) { el.__llstIO.disconnect(); el.__llstIO = null; } initMap(el); };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) go(); });
      }, { rootMargin: '600px' });
      io.observe(el);
      el.__llstIO = io;
    }
    if ('requestIdleCallback' in window) { requestIdleCallback(go, { timeout: 2500 }); }
    else { setTimeout(go, 1200); }
  }

  function destroy(root) {
    var el = (root || document).querySelector('[data-llst-map]');
    if (!el) return;
    if (el.__llstIO) { el.__llstIO.disconnect(); el.__llstIO = null; }
    if (el.__llstMap) { el.__llstMap.remove(); el.__llstMap = null; }
    el.__llstMapInit = false; el.__llstObserved = false;
  }

  function bootAll() { document.querySelectorAll('[data-llst-map]').forEach(function (el) { boot(el.closest('[id^=llst-]') || document); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootAll); else bootAll();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { destroy(e.target); });
})();
